import { render, staticRenderFns } from "./promo-planner-container.vue?vue&type=template&id=b8138d66&scoped=true"
import script from "./promo-planner-container.vue?vue&type=script&lang=js"
export * from "./promo-planner-container.vue?vue&type=script&lang=js"
import style0 from "./promo-planner-container.vue?vue&type=style&index=0&id=b8138d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8138d66",
  null
  
)

export default component.exports